import { render, staticRenderFns } from "./userMyInforShow.vue?vue&type=template&id=5edd65a4&scoped=true"
import script from "./userMyInforShow.vue?vue&type=script&lang=js"
export * from "./userMyInforShow.vue?vue&type=script&lang=js"
import style0 from "./userMyInforShow.vue?vue&type=style&index=0&id=5edd65a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edd65a4",
  null
  
)

export default component.exports